// Module-level singletons replacing Vue 2 `Vue.prototype.*` patterns.
// Plain getters/setters so non-Vue files (helpers, filters) can read them
// without depending on a component instance or `app.config.globalProperties`.

let _ncProfile = { HideFileExtensions: false };
let _browserLocale = "da-DK";

/**
 * Returns the current NC profile object.
 * @returns {object} The NC profile singleton
 */
export function getNcProfile() {
  return _ncProfile;
}

/**
 * Replaces the current NC profile singleton.
 * @param {object} profile The new NC profile object
 */
export function setNcProfile(profile) {
  _ncProfile = profile;
}

/**
 * Returns the current browser locale string.
 * @returns {string} The active browser locale (e.g. "da-DK")
 */
export function getBrowserLocale() {
  return _browserLocale;
}

/**
 * Replaces the current browser locale singleton.
 * @param {string} locale The new locale string
 */
export function setBrowserLocale(locale) {
  _browserLocale = locale;
}
